import {fetchAndDeserialize} from '../../util/api-adapter';
import {objectToUrlParameters} from '../../util/url';

import {helpLinkSchema, HelpLinksOptionsType, HelpLinkType} from './help-links-type';

export async function fetchHelpLinks(options: HelpLinksOptionsType): Promise<Array<HelpLinkType>> {
    const url = `/cp/help_links/?${objectToUrlParameters({
        domain: options.domainName,
    })}`;

    // `fetchX` caches GET promises for the whole session, so without `skipCache` the polling
    // in `HelpLinksProvider` would keep replaying the very first response.
    return fetchAndDeserialize(url, helpLinkSchema.array(), {fetchOptions: {skipCache: true}});
}
